import dateTimeHelper from '../../../Helpers/datetimeHelper';
import UserService from '../../../Services/userService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import SearchParamsBase from '../../../Elements/SearchParamsBase';
import FeeTypesEnum from '../../../Enums/FeeTypesEnum';

export default class FpaSearchParams extends SearchParamsBase {
  constructor(id) {
    super();
    if (id !== undefined) {
      this.FreelancerUserIdOrName = id.toString();
    }
  }

  initialize() {
    this.FreelancerUserIdOrName = '';
    this.FeeType = '';
    this.OfficeId = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.InvoicingStatus = [5];
    this.ClientIdOrName = '';
    this.SurveyIdOrName = '';
    this.WaveIdOrName = '';
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.addMonthsToDate(
      dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.firstDayOfTheActualMonth()),
      -6
    );
    this.EndDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.lastDayOfTheActualMonth());
    this.ApprovalStatus = '';
    this.FreelancerInvoiceId = '';
    this.FreelancerFeeId = '';
    this.FreelancerPayableAssignmentsId = '';
    this.IsSameIndividual = '';
    this.ThirdPartySource = '';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'FreelancerUserIdOrName',
      label: 'Vendor (Id or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'FeeType',
      label: 'Type',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: FpaSearchParams.getSelectValuesForFeeType(),
    },
    {
      fieldName: 'OfficeId',
      label: 'Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupSelect,
      roleKey: 'Freelancer_inputfield_VendorAdminFinanceAdmin',
    },
    {
      fieldName: 'InvoicingStatus',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.MultiChoice,
      options: FpaSearchParams.getStatusList(),
    },
    { fieldName: 'FreelancerFeeId', label: 'FeeId', className: 'col-3', type: InputTypesEnum.Text },
    {
      fieldName: 'ClientIdOrName',
      label: 'Client (SassieId or Third-Party ID or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'SurveyIdOrName',
      label: 'Survey (Third Party ID or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'WaveIdOrName',
      label: 'Wave (Third Party ID or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    { fieldName: 'UseDateRange', label: 'Use Date Range', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    { fieldName: 'FreelancerInvoiceId', label: 'Invoice Id', className: 'col', type: InputTypesEnum.Number },
    {
      fieldName: 'FreelancerPayableAssignmentsId',
      label: 'Id (Third Party Job ID or Caspian or F.P.A.)',
      className: 'col',
      type: InputTypesEnum.Number,
    },
    {
      fieldName: 'IsSameIndividual',
      label: 'Is Same Individual?',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    {
      fieldName: 'ThirdPartySource',
      label: 'Source',
      className: 'col-3',
      type: InputTypesEnum.ThirdPartySourceSelect,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'FpaSearchParams';

  static getSelectValuesForFeeType() {
    return selectHelper.generateSelectValues(['', FeeTypesEnum.RM, FeeTypesEnum.DQ]);
  }

  static getStatusList() {
    let statusList = [
      { value: 1, label: 'AssignmentExcludedExcl' },
      { value: 2, label: 'NoFee' },
      { value: 3, label: 'AssignmentCreated' },
      { value: 4, label: 'AssignmentCompleted' },
      { value: 5, label: 'ReadyForInvoicing' },
      { value: 6, label: 'OnDraftInvoice' },
      { value: 7, label: 'OnFinalizedInvoice' },
      { value: 8, label: 'Uninvoiceable' },
    ];
    return statusList;
  }
}
